import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';
import { UpcomingTrips } from '@/components/customer/UpcomingTrips';
import { Plane, MapPin, Calendar, Users } from 'lucide-react';

export function TripsPage() {
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {t('dashboard.customer.dashboard.upcomingTrips.title')}
        </h1>
        <p className="text-muted-foreground">
          {t('dashboard.customer.dashboard.upcomingTrips.description')}
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-[1fr_300px]">
        <div className="space-y-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <UpcomingTrips />
          </motion.div>
        </div>

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MapPin className="h-5 w-5" />
                {t('dashboard.customer.dashboard.upcomingTrips.tripDetails.location')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <h3 className="font-medium">منتجع العلا</h3>
                <p className="text-sm text-muted-foreground">
                  تجربة فريدة في قلب التاريخ والطبيعة
                </p>
              </div>
              <div className="space-y-2">
                <h3 className="font-medium">هايكنج السودة</h3>
                <p className="text-sm text-muted-foreground">
                  مغامرة في أعلى قمم المملكة
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Calendar className="h-5 w-5" />
                {t('dashboard.customer.dashboard.upcomingTrips.tripDetails.date')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>الرحلة القادمة</span>
                  <span>15 أبريل 2024</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>الرحلة التالية</span>
                  <span>20 أبريل 2024</span>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Users className="h-5 w-5" />
                {t('dashboard.customer.dashboard.upcomingTrips.tripDetails.registered')}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>منتجع العلا</span>
                  <span>15/20</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span>هايكنج السودة</span>
                  <span>15/15</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
} 